import { Trip } from '../../lib/types/models/trip/trip'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

type Input = {
  journeyId: number
  tripPlaceId?: number
  published?: boolean
}

export const getSecondaryTripsByTripPlace = (input: Input) => {
  const { journeyId, ...rest } = input
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.products.getSecondaryTripsByTripPlace.url, { id: journeyId }),
        rest
      )
    )
    .get<Trip[]>()
}
